<template>
    <!-- Loader wrap -->
    <div class="loader_wrap">
        <!-- Loader -->
        <div class="loader"><span></span></div>
    </div>
</template>